import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["values", "className"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { DatePicker } from 'antd';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';

// Constants
import { EMPTY_ARRAY, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
var RangePicker = DatePicker.RangePicker;
var DateRange = /*#__PURE__*/function (_PureComponent) {
  _inherits(DateRange, _PureComponent);
  var _super = _createSuper(DateRange);
  function DateRange() {
    var _this;
    _classCallCheck(this, DateRange);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
      var onChange = _this.props.onChange;
      var _value = _slicedToArray(value, 2),
        startMoment = _value[0],
        endMoment = _value[1];
      if (_isEmpty(value)) return onChange(EMPTY_ARRAY);
      return onChange([startMoment.startOf('day'), endMoment.endOf('day')]);
    });
    return _this;
  }
  _createClass(DateRange, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        values = _this$props.values,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement(RangePicker, _extends({
        separator: "-",
        allowClear: false,
        value: values
      }, rest, {
        onChange: this.handleChange
      })));
    }
  }]);
  return DateRange;
}(PureComponent);
DateRange.propTypes = {
  onChange: PropTypes.func,
  values: PropTypes.array,
  className: PropTypes.string
};
DateRange.defaultProps = {
  onChange: _noop,
  values: EMPTY_ARRAY,
  className: EMPTY_STRING
};
export default DateRange;